import {_RecensioniCRUD as RecensioniCRUD} from "./_RecensioniCRUD";
import {_RecensioniInfoForLauncher as RecensioniInfoForLauncher} from "./_RecensioniInfoForLauncher";

export const RecensioniAPI = {
    RecensioniCRUD: RecensioniCRUD,
    RecensioniInfoForLauncher: RecensioniInfoForLauncher
};